import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { getBoundingClientRect } from '../../../utils/functions';
import FixedView from "../../FixedView";
import FormViewer from "../../FormViewer";
import { checkTranslation, getObject } from "../../../utils/useful";
import tableComponents from '../../tableComponents'
import ActionButton from "../../partials/ActionButton";
import IntractionActionsList from "../../IntractionActionsList";
import CardRenderer from "../../CardRenderer";
import ActionsBtn from "../../partials/ActionsBtn";

class ColumnItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            headers: [],
            edit: [
                { title: "Rename", icon: "/assets/icons/highlighter.svg" },
                { title: "Bookmark", icon: "/assets/icons/line.3.horizontal.decrease.svg" },
            ],
            show: true,
        }
        this.more = React.createRef();
        this.moreOption = React.createRef();
        this.setPositionDiv = React.createRef();
    }

    // componentDidMount() {
    //     // console.log('props====', this.props)
    //     this.init()
    // }


    componentDidUpdate(prevProps) {

        // console.log(this.props.view?.settings)
        if (this.props.view?.settings?.cardInfo != this.state.cardInfo) {
            this.init()
        }
    }

    componentDidMount() {
        // console.log('props====', this.props)
        let mainHeaders = [...this.props.headers]
        let headers = []
        // let headersKey = Object.keys(this.props.headersData)
        // headers = headers.filter(header => headersKey.includes(header.key))
        mainHeaders.forEach(header => {
            let valid = getObject(this.props.headersData, header.key) ?? getObject(this.props.headersData, ('**files.' + header.key), 1) ?? false
            if (valid) {
                // header.information.disabled = true
                headers.push(header)
            }
        })
        this.setState({ headers, show: false }, () => {
            this.setState({ show: true })
            this.init()
        })

    }



    init() {

        this.setState({ cardInfo: this.props.view?.settings?.cardInfo })

        // console.log('this.props.view?.settings', this.props.view?.settings)
        let cardElements = []
        let content = this.props.view?.settings?.cardInfo

        this.setState({ content })
    }



    Openmoremenu = () => {
        this.more.showView();
    }

    actionClicked = (prop, data, index) => {
        this.props.functionsHandler('collection', prop, data, index)

    }

    onDragStart = () => {

    }

    render() {
        return (
            <>
                <div style={{ position: "fixed", top: "0", left: "0" }} ref={el => this.setPositionDiv = el}></div>

                <Draggable draggableId={`${this.props.itemId}`} index={this.props.index} onDragStart={() => this.onDragStart()}>
                    {(provided, snapshot) => {

                        // console.log('provided', provided, snapshot)
                        if (snapshot.isDragging) {
                            if (!provided.draggableProps) {
                                provided.draggableProps = { style: {} }
                            }
                            let bound = getBoundingClientRect(this.setPositionDiv)
                            const offset = { x: bound.left, y: bound.top }
                            // console.log(offset.x, offset.y)
                            const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                            const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                            // console.log("y:", y, "x:", x)
                            provided.draggableProps.style.left = x;
                            provided.draggableProps.style.top = y;
                            provided.draggableProps.style.boxShadow = '0px 20px 50px #10101050';

                            // provided.draggableProps.style.backgroundColor = 'red';


                        }
                        return (
                            <div className={"single-list "} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} onClick={() => this.actionClicked('openEditModal', this.props.headersData, this.props.index)}>
                                <div className="item w-100" style={{ justifyContent: "space-between" }}>
                                    <div className="flexcb flex-column  w-100">
                                        {/* <p className="item-text" style={{ overflowWrap: "anywhere" }}>{this.props.taskName}</p> */}
                                        {this.state.show &&
                                            <div className="w-100 ">



                                                <div className="px-2 pt-1">

                                                    <CardRenderer content={this.state.content} data={this.props.headersData} params={this.props.params} width={this.props.width} variables={this.props.variables} changeWindowLink={this.props.changeWindowLink} baseUrl={this.props.baseUrl ? [...this.props.baseUrl] : null} windowData={this.props.windowData} colors={this.props.colors} changePage={this.props.changePage} pageChangePage={this.props.pageChangePage} applet={this.props.applet} userView={this.props.userView} headers={this.props.headers} functionsHandler={this.props.functionsHandler} />

                                                    {/* {this.state.headers?.map((header, index) => {
                                                        if (!this.props.view?.settings?.visibleKeys || this.props.view?.settings?.visibleKeys.includes(header.key)) {

                                                            let data = getObject(this.props.headersData, header.key)
                                                            let Component = tableComponents[header.type]
                                                            let styleInfo
                                                            if(this.props.view?.settings?.cardInfo){
                                                                styleInfo = this.props.view?.settings?.cardInfo[header.key]
                                                            }else{
                                                                if(header.type == 'TextAreaInput'){
                                                                    styleInfo = {fontSize:14}
                                                                }
                                                                if(header.type == 'TextInput'){
                                                                    styleInfo = {fontSize:16,fontWeight:500}
                                                                }
                                                            }
                                                            
                                                            return (
                                                                <div className="mb-1">
                                                                    {Component && (
                                                                        <Component data={data} header={header} changeValue={this.changeValue} changeFiles={this.changeFiles} extra={{ index: this.props.index, _id: this.props.id }} cardField={true} styleInfo={styleInfo}/>
                                                                    )}
                                                                </div>
                                                            )

                                                        }
                                                    })} */}



                                                </div>

                                                <div className="flexc pt-2 mt-0" style={{ borderTop: 'px solid #eee' }}>
                                                    
                                                    {this.props.actions && (
                                                        <div className='mrd-2 pld-2 flexcc' style={{}} onClick={(e) => e.stopPropagation()}>
                                                            <ActionsBtn permissions={this.props.permissions} page={this.props.page} applet={this.props.applet} data={this.props.data} index={this.props.index} actions={this.props.actions} actionClicked={this.actionClicked} language={this.props.language} currentRecord={this.props.currentRecord} currentRecordStage={this.props.currentRecordStage} changeRecordStage={this.props.changeRecordStage} setCurrentRecordStage={this.props.setCurrentRecordStage} colors={this.props.colors} functionsHandler={this.props.functionsHandler} />
                                                        </div>
                                                    )}



                                                    <div className="br-20 flexcc opacity-2 mrd-2" style={{ height: 20, width: 20, border: '1px dashed #000' }}>
                                                        <img className="" src="/assets/icons/time-chart.svg" height={14} />
                                                    </div>

                                                    <div className="br-20 flexcc opacity-2" style={{ height: 20, width: 20, border: '1px dashed #000' }}>
                                                        <img className="" src="/assets/icons/useful/stack1.png" height={14} />
                                                    </div>


                                                </div>
                                            </div>
                                        }
                                    </div>

                                    {/* <div className="flexcb flex-column h-100 flexcb mld-4">
                                        <button ref={el => this.moreOption = el} className='flexcc more-box br-5 p-1' onClick={() => this.Openmoremenu()}>
                                            <img width={22} src="/assets/icons/more-black.svg" />
                                        </button>
                                        <img className="user-icon mt-3" src='\assets\icons\person-black.svg' />
                                    </div> */}
                                </div>
                                {/* <div>
                                    <FixedView ref={el => this.more = el} nodeRef={this.moreOption} showFocus={false} topOffset={7} xOffset={140} zIndex={300}>
                                        <div className='shadow-2 br-10 py-1 px-2' style={{ backgroundColor: "#fff", width: "180px" }}>
                                            {this.state.edit.map((prop, index) => {
                                                return (
                                                    <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5'
                                                    >
                                                        <img className='mrd-3 flexcc' src={prop.icon} />
                                                        <p className='text-start des-color'>{prop.title}</p>
                                                    </button>
                                                )
                                            })}
                                            {this.props.actions && Object.values(this.props.actions).map((propAct, index) => {
                                                return (
                                                    <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' onClick={() => [propAct.function(this.props.dataRow, this.props.index), this.more.hideView()]}
                                                    >
                                                        <p className='text-start des-color'>{checkTranslation(propAct.label)}</p>
                                                    </button>
                                                )
                                            })}

                                            <div className='mx-2' style={{ borderTop: "1px solid #c8c8c8" }}>
                                            </div>
                                            <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' >
                                                <img className='mrd-3 flexcc' src='/assets/icons/trash.svg' />
                                                <p className='text-start' style={{ color: "#EF1919" }} onClick={() => this.props.removeNewSubColumn()}>Delete section</p>
                                            </button>
                                        </div>
                                    </FixedView>
                                </div> */}
                            </div>
                        )
                    }}
                </Draggable></>
        );
    }
};

export default ColumnItem;
